// Note(greg): This funciton is checking for a trailing
// slash '/' at the end of /cityoflondon/. This shouldn't
// be necessary but the vue router ignores trailing slashes
// and therefore this function is required for something so
// trivial.
export default function checkForCityOfLondon(entity, to) {
  const hasPath = to.path;
  const isCityOfLondon =
    hasPath && to.path.toLowerCase().includes('/cityoflondon/');
  const isUK = entity.entity === 'UK';
  const shouldRedirectToPopup = isUK && hasPath && isCityOfLondon;
  return shouldRedirectToPopup;
}
